/** Shopify CDN: Minification failed

Line 41:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 50:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 60:8 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 32:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:8 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 21:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 22:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 26:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 30:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:8 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 11:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 12:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 28:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 30:8 Transforming const to the configured target environment ("es5") is not supported yet

**/
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
